/* Auvra dispatch countdown — real Europe/London cutoff, no fake urgency.
   Mounts on every [data-auvra-countdown]. Config via data attributes:
   data-cutoff-hour="14"  data-holidays="2026-12-25,2026-12-28"  */
(function () {
  'use strict';
  if (window.__auvraCountdownInit) return;
  window.__auvraCountdownInit = true;
  var DAY_NAMES = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];

  function londonNow() {
    // Parts of "now" in Europe/London regardless of the visitor's zone.
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London', hour12: false,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', weekday: 'short'
    }).formatToParts(new Date());
    var p = {};
    parts.forEach(function (x) { p[x.type] = x.value; });
    return {
      y: +p.year, m: +p.month, d: +p.day,
      hh: +p.hour % 24, mm: +p.minute, ss: +p.second,
      dow: { Sun:0, Mon:1, Tue:2, Wed:3, Thu:4, Fri:5, Sat:6 }[p.weekday]
    };
  }
  function iso(y, m, d) {
    return y + '-' + String(m).padStart(2, '0') + '-' + String(d).padStart(2, '0');
  }
  function addDays(y, m, d, n) {
    var t = new Date(Date.UTC(y, m - 1, d + n));
    return { y: t.getUTCFullYear(), m: t.getUTCMonth() + 1, d: t.getUTCDate(), dow: t.getUTCDay() };
  }
  function isWorking(day, holidays) {
    return day.dow !== 0 && day.dow !== 6 && holidays.indexOf(iso(day.y, day.m, day.d)) === -1;
  }
  function nextWorking(from, holidays, includeToday) {
    var day = includeToday ? from : addDays(from.y, from.m, from.d, 1);
    for (var i = 0; i < 30; i++) {
      if (isWorking(day, holidays)) return day;
      day = addDays(day.y, day.m, day.d, 1);
    }
    return day;
  }
  function render(el) {
    var global = window.AUVRA_COUNTDOWN || {};
    var cutoff = parseInt(el.getAttribute('data-cutoff-hour') || global.cutoff || '14', 10);
    var holidays = (el.getAttribute('data-holidays') || global.holidays || '')
      .split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var now = londonNow();
    var today = { y: now.y, m: now.m, d: now.d, dow: now.dow };
    var beforeCutoff = now.hh < cutoff;

    if (beforeCutoff && isWorking(today, holidays)) {
      var minsLeft = (cutoff * 60) - (now.hh * 60 + now.mm) - (now.ss > 0 ? 1 : 0);
      var h = Math.floor(minsLeft / 60), m = minsLeft % 60;
      el.textContent = 'Order within ' + (h > 0 ? h + 'h ' : '') + m + 'm (4pm Mon–Fri cut-off) for FREE next-working-day delivery'; /* v5.1 wording */
    } else {
      var dispatch = nextWorking(today, holidays, false);
      var delivery = nextWorking(dispatch, holidays, false);
      el.textContent = 'Order now for delivery ' + DAY_NAMES[delivery.dow];
    }
  }
  function tick() {
    document.querySelectorAll('[data-auvra-countdown]').forEach(render);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tick);
  } else { tick(); }
  setInterval(tick, 30000);
})();
